module.exports = __webpack_public_path__ + "img/flag1.aa47ba21.svg";